import React from 'react';
import Slider from './Slider/Slider';
import Body from './Body/Body';
import BodySection from './Body/bodysection/BodySection';
import Bodysection2 from './Body/Section2/Bodysection2';
// import Bodysection3 from './Body/Bodysection3/Bodysection3';
import BodySection4 from './Body/Bodysection4/BodySection4';
import FooterSection1 from './Footer/FooterSection1';



const Home = () => {
  return (
    <>

      <Slider />
      <Body />
      <BodySection />
      <Bodysection2 />
      {/* <Bodysection3 /> */}
      {/* <BodySection4 /> */}
      <FooterSection1 />
    </>
  );
};

export default Home;
